

export const wanExamples = {
    title: 'Wan 2.5 原生音频视频范例',
    sub: '看看 Wan 2.5 如何将文字与图片转化为完整的音视频体验',
    imageToVideoTitle: '图片转视频（含音频）',
    imageToVideoDesc: '把静态图片转化为带同步配乐、对白与环境音的动态视频，既保持视觉一致性，又加入真实运动与原生音频。',
    sectionLabel: '输入',
    textToVideoTitle: '文字转视频（原生音频）',
    textToVideoDesc: '仅凭文字描述即可生成完整视频，包括画面、对白与音乐。原生音频与唇形、场景节奏精准对齐，呈现电影级效果。',
    promptText: '「夜晚的爵士酒吧，灯光昏暗，木桌在暖色吊灯下微微发光。客人啜饮饮品并低声交谈，舞台上三人乐队正在演奏……」'
  };
